import { render } from "./SectionSolutionWelcome.vue?vue&type=template&id=64905eab&scoped=true"
import script from "./SectionSolutionWelcome.vue?vue&type=script&lang=js"
export * from "./SectionSolutionWelcome.vue?vue&type=script&lang=js"

import "./SectionSolutionWelcome.vue?vue&type=style&index=0&id=64905eab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64905eab"]])

export default __exports__